import styles from './History.module.scss';

import { EntityHistory } from '@work4all/components/lib/components/entity-preview/EntityHistory';
import { mapHistoryEventEntity } from '@work4all/components/lib/components/entity-preview/erp-preview/ErpPreview';

import { useMaskContext } from '../../hooks/mask-context';

export const History = () => {
  const mask = useMaskContext();

  return (
    <div className={styles.root}>
      <EntityHistory
        entity={mapHistoryEventEntity(mask.entity)}
        id={mask.id}
        breadcrumbTitle={mask.entity}
        fullWidth
        fullCommentEditor
        withTabs
      />
    </div>
  );
};
